import React from "react";
import { NavLink } from "react-router-dom";

const SalesNav: React.FC = () => (
  <nav className="sales-nav">
    <NavLink className="sales-nav__link" exact to="/sales">
      Resumen
    </NavLink>
    <NavLink className="sales-nav__link" to="/sales/orders">
      Órdenes
    </NavLink>
    <NavLink className="sales-nav__link" to="/sales/products">
      Productos
    </NavLink>
    <NavLink className="sales-nav__link" to="/sales/by-person">
      Por Persona
    </NavLink>
  </nav>
);

export default SalesNav;
